var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplateTileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 0.393555,
    y: 0.516479,
    width: 27.22,
    height: 27.22,
    rx: 4,
    fill: "#339EEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5034 11.6265H16.5034",
    stroke: "#339EEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5034 14.1265H16.5034",
    stroke: "#339EEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5034 16.6265H14.0034",
    stroke: "#339EEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2445 21.0015H7.75342C7.58766 21.0015 7.42869 20.9356 7.31148 20.8184C7.19427 20.7012 7.12842 20.5422 7.12842 20.3765V7.87648C7.12842 7.71072 7.19427 7.55175 7.31148 7.43454C7.42869 7.31733 7.58766 7.25148 7.75342 7.25148H20.2534C20.4192 7.25148 20.5781 7.31733 20.6954 7.43454C20.8126 7.55175 20.8784 7.71072 20.8784 7.87648V16.3676C20.8784 16.4497 20.8623 16.5309 20.8308 16.6068C20.7994 16.6826 20.7534 16.7515 20.6954 16.8095L16.6865 20.8184C16.6284 20.8765 16.5595 20.9225 16.4837 20.9539C16.4079 20.9853 16.3266 21.0015 16.2445 21.0015V21.0015Z",
    stroke: "#339EEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8219 16.6259H16.5034V20.9446",
    stroke: "#339EEC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateTileIcon);
export default __webpack_public_path__ + "static/media/template-tile-icon.1fc833be9a378bcdfe12c52db796d4e5.svg";
export { ForwardRef as ReactComponent };